export default "__VITE_ASSET__53c7df80__"